import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import Table from "../../components/Table";
import Loader from "../../components/Loader";
import { microsoftColumn } from "../../components/headerContent";
import RowMicrosoftOverview from "./RowMicrosoftOverview";

export default function MicrosoftOverview() {
    const { apiUrl } = useContext(AuthContext);

    const statusMap = {
        serviceOperational: "Opérationnel",
        investigating: "Investigation",
        restoringService: "Restauration",
        verifyingService: "Vérification",
        serviceRestored: "Service restauré",
        postIncidentReviewPublished: "Rapport d'incident publié",
        serviceDegradation: "Dégradation",
        serviceInterruption: "Interruption",
        extendedRecovery: "Correction",
        falsePositive: "Faux positif",
        investigationSuspended: "Investigation suspendue",
        resolved: "Résolu",
        confirmed: "Confirmé",
        reported: "Reporté"
    }

    const getOverview = async () => {
        const res = await axios.get(`${apiUrl}microsoft/healthOverview`, { withCredentials: true })
        return res.data.value.map((item) => ({ ...item, status: statusMap[item.status] }))
    }

    const healthOverview = useQuery({
        queryKey: ["healthOverview"],
        queryFn: getOverview
    })

    return (
        <>
            {!healthOverview.isLoading ?
                <div className='cato-content-table mt-1'>
                    <Table
                        tableData={healthOverview.data}
                        tableColumns={microsoftColumn}
                        rowComponent={RowMicrosoftOverview}
                        checkbox={false}
                    />
                </div>
                : <Loader />}
        </>
    )
}